import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => ({
    root: {
      '& > * + *': {
        marginTop: '32px',
      },
    },
    content: {},
    doubleSpacing: {
      '&:not(:first-child)': {
        marginTop: '58px',
      },

      '& + *': {
        marginTop: '58px',
      },
    },
  }),
  { name: 'GenPressReleaseContent' },
);

export default useStyles;
